import { updateAdvTimes } from '@/plugins/vue-cookies';

const isSupportWebp = (() => {
  try {
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
  } catch (err) {
    return false;
  }
})();

// 小于10补0
export function fillZero(num) {
  return num < 10 ? '0' + num : '' + num;
}

// 日期时间格式化
export function timeFormat(timestamp, formater) {
  const date = timestamp ? new Date(timestamp) : new Date();
  const formatMap = {
    'y+': date.getFullYear(),
    'm+': fillZero(date.getMonth() + 1),
    'd+': fillZero(date.getDate()),
    'h+': fillZero(date.getHours()),
    'i+': fillZero(date.getMinutes()),
    's+': fillZero(date.getSeconds()),
  };
  formater = formater ? formater.toLowerCase() : 'y-m-d h:i:s';
  for (const item in formatMap) formater = formater.replace(new RegExp(item), formatMap[item]);
  return formater;
}

// 日期时间转文字描述
export function timeToStr(data) {
  const create = new Date(data).getTime() / 1000;
  const nowTime = new Date().getTime() / 1000;
  const inter = nowTime - create;
  if (inter < 60) return '刚刚';
  if (inter < 3600) return Math.floor(inter / 60) + '分钟前';
  if (inter < 24 * 3600) return Math.floor(inter / 3600) + '小时前';
  if (inter < 30 * 24 * 3600) return Math.floor(inter / (24 * 3600)) + '天前';
  return timeFormat(data, 'YYYY-MM-DD');
}

// 数字格式化 加,
export const numberFormat = num => num.toLocaleString('en-US');

// 距离格式化
export function distanceFormat(distance) {
  if (distance === undefined) return '';
  distance = parseFloat(distance);
  if (distance < 10000) return distance.toFixed(0);
  return (distance / 10000).toFixed(1) + '万';
}

// 跨域名跳转
export function hostBuild(data, host) {
  /**
   * 该过滤器只在跨域名的时候使用
   * 需要传入二级域名 例如 car
   * 使用a 标签进行渲染
   * 返回的是 一个绝对路径
   */
  const hostName = window.location.hostname;
  const reg = /[^.\s]+\.([^.\s]+)$/g;
  const regResult = reg.exec(hostName);
  // if (regResult == null) return '#测试环境不能跳转';
  // if (host == undefined || host.length == 0) return '//' + regResult[0] + data;
  if (host == undefined) {
    throw new Error('hostBuild 方法缺少参数 host');
  }
  if (regResult === null) return `//${host}0.yorktest.xyz${data}`;
  const isZero = hostName.indexOf('0') != -1 ? '0' : '';
  return '//' + host + isZero + '.' + regResult[0] + data;
}

// 金钱格式化 分为单位
export const moneyFormat = cent => Number(`${Math.round(cent)}e-2`).toLocaleString('en-US');

// 标题格式化
export function titleFormat(title, len = 40) {
  if (!title) return '';
  let titleLen = 0;
  for (let i = 0; i < title.length; i++) {
    const charCodeAt = title[i].charCodeAt(i);
    if (charCodeAt >= 0 && charCodeAt <= 128) {
      // 非中文按一个长度计算
      titleLen += 1;
    } else {
      // 中文按两个长度计算
      titleLen += 2;
    }
  }
  return titleLen > len ? title.substring(0, len) + '...' : title;
}

// 手机号码格式化
export function phoneFormat(phoneNum) {
  if (typeof phoneNum !== 'string') return '';
  phoneNum = phoneNum.replace(/[^\d]/g, '');
  const regex = phoneNum.length == 11 ? /(\d{3})(\d{0,4})?(\d+)?/ : /(\d{3})(\d{0,3})?(\d+)?/;
  return phoneNum.replace(regex, (match, p1, p2, p3) => {
    return `${p1}-${p2}-${p3}`;
  });
}

// 用户数据格式化（关注、粉丝、积分、获赞 ）
export function userDataFormat(num) {
  if (typeof num !== 'number') return '';
  if (num < 1000) return num + '';
  if (num >= 1000 && num < 1000000) return (num / 1000).toFixed(1) + 'K';
  if (num >= 1000000 && num < 1000000000) return (num / 1000000).toFixed(1) + 'M';
  return (num / 1000000000).toFixed(1) + 'B';
}

/**
 * 获取元素距离浏览器顶部的距离
 */
export function getOffsetTop(el) {
  let top = el.offsetTop;
  el = el.offsetParent;
  while (el != null) {
    top += el.offsetTop;
    el = el.offsetParent;
  }
  return top;
}

/**
 * 获取浏览器可视区域尺寸
 * @param {Element} w 窗口
 */
export function getViewportSize(w) {
  //使用指定的窗口， 如果不带参数则使用当前窗口
  w = w || window;

  //除了IE8及更早的版本以外，其他浏览器都能用
  if (w.innerWidth != null) return { w: w.innerWidth, h: w.innerHeight };

  //对标准模式下的IE（或任意浏览器）
  var d = w.document;
  if (document.compatMode == 'CSS1Compat')
    return { w: d.documentElement.clientWidth, h: d.documentElement.clientHeight };

  //对怪异模式下的浏览器
  return { w: d.body.clientWidth, h: d.body.clientHeight };
}

/**
 * 检测滚动条是否滚动到页面底部
 * @param {Number} distance 距离浏览器底部的距离
 */
export function isScrollToPageBottom(distance = 500) {
  var documentHeight = document.documentElement.offsetHeight;
  var viewPortHeight = getViewportSize().h;
  var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  return documentHeight - viewPortHeight - scrollHeight < distance;
}

/**
 * 设置 HTML 标题 关键词 描述信息
 */
export function setHtmlMeta({ title, keywords, description }) {
  if (title) {
    document.title = title;
  }
  if (keywords) {
    document.querySelector('meta[name=keywords]').content = keywords;
  }
  if (description) {
    document.querySelector('meta[name=description]').content = description;
  }
}

/**
 * 深复制
 */
export function deepClone(o) {
  // 判断如果不是引用类型，直接返回数据即可
  if (typeof o === 'string' || typeof o === 'number' || typeof o === 'boolean' || typeof o === 'undefined') {
    return o;
  } else if (Array.isArray(o)) {
    // 如果是数组，则定义一个新数组，完成复制后返回
    // 注意，这里判断数组不能用typeof，因为typeof Array 返回的是object
    var _arr = [];
    o.forEach(item => {
      _arr.push(item);
    });
    return _arr;
  } else if (typeof o === 'object') {
    var _o = {};
    for (let key in o) {
      _o[key] = deepClone(o[key]);
    }
    return _o;
  }
}

/**
 * HTML特殊符号实体转换普通字符串（兼容 A7 历史数据）
 */
export function specialSymbol2String(str) {
  let div = document.createElement('div');
  div.innerHTML = str;
  const s = div.innerText || div.textContent;
  div = null;
  return s;
}

/**
 * 将字符串的手写字母转换为大写
 * @param {String} str 字符串
 * @returns 首字母大写的字符串
 */
export const firstLetterUpperCase = str => {
  str = str + '';
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};

/**
 * 根据毫秒数计算时间
 * @param {Number}} ms 毫秒
 * @returns 剩余时间对象
 */
export const getRemainingTime = ms => {
  let d, h, m, s;
  if (ms > 0) {
    d = Math.floor(ms / (1000 * 60 * 60 * 24)) + '';
    h = Math.floor((ms / (1000 * 60 * 60)) % 24) + '';
    m = Math.floor((ms / (1000 * 60)) % 60) + '';
    s = Math.floor((ms / 1000) % 60) + '';
  } else {
    d = '0';
    h = '0';
    m = '0';
    s = '0';
  }

  return { d, h, m, s, dd: d.padStart(2, '0'), hh: h.padStart(2, '0'), mm: m.padStart(2, '0'), ss: s.padStart(2, '0') };
};

/**
 * 从数组中随机获取指定数量的元素
 * @param arr 数组
 * @param n 元素个数
 * @returns 包含指定数量随机元素的数组
 */
export const getRandomItems = (arr, n = 1) => {
  let a = [...arr],
    m = arr.length;
  while (m) {
    const i = Math.floor(Math.random() * m--);
    [a[m], a[i]] = [a[i], a[m]];
  }
  return a.slice(0, n);
};

/**
 * 图片广告数据转换
 * @param {array} advs 广告列表
 * @param {string} system 系统（二级域名）
 * @param {number} zoomId 页面ID
 * @returns 广告数据
 */
export const bannerAdvConvert = (advs, system, zoomId, adType = 'banner') => {
  const adv = (advs || []).reduce((acc, curr) => {
    const key = curr.showType == 3 ? curr['placement'] : curr['placement'] + '_' + curr['position'];
    if (acc[key]) {
      acc[key]['list'] = [...acc[key]['list'], { ...curr.data, width: curr.width, height: curr.height }];
    } else {
      acc[key] = { ...curr, list: [{ ...curr.data, width: curr.width, height: curr.height }] };
      delete acc[key]['data'];
    }
    return acc;
  }, {});

  const times = updateAdvTimes(adType, system, zoomId);

  return Object.keys(adv).reduce((acc, key) => {
    const curr = adv[key];
    acc[key] = { ...curr };
    if (curr.showType == 3) {
      acc[key]['list'] = [...curr.list];
    } else {
      acc[key] = { ...acc[key], ...curr.list[times % curr.list.length] };
      delete acc[key]['list'];
    }

    return acc;
  }, {});
};

/**
 * 信息流数据转换
 * @param {array} infos 信息流
 * @param {string} system 系统（二级域名）
 * @param {number} zoomId 页面ID
 * @returns 信息流数据
 */
export const inflowAdvConvert = (infos, system, zoomId, adType = 'inflow') => {
  if (!infos.some(info => info.app == 'crm_ad')) return infos;

  const times = updateAdvTimes(adType, system, zoomId);

  infos.forEach(info => {
    if (info.app == 'crm_ad') {
      info.material = info.material[times % info.material.length];
    }
  });

  return infos;
};

/**
 * 获取一级域名
 */
export const getTopHostname = (hostname = window.location.hostname) => {
  const m = hostname.match(/(\w+\.\w+)$/);
  return m ? m[0] : '';
};

/**
 * 是否是本站图片链接
 */
export const isMediaUrl = url =>
  new RegExp('^(https?:)?//media\\.(' + getTopHostname() + '|canada-cn\\.net)').test(url);

/**
 * 移除本站图片样式
 */
export const removeMediaUrlSuffix = url => {
  const regex = /\/(webp\d+|watermark)$/;
  while (regex.test(url)) url = url.replace(regex, '');
  return url;
};

/**
 * 普通图片链接转换成webp链接
 */
export function webpFormat(url, size) {
  if (!url) return;
  if (typeof size != 'number') throw new Error('webp size must be a number');

  //if (isMediaUrl(url)) {
    url = removeMediaUrlSuffix(url);
    if (isSupportWebp) return `${url}/webp${size}`;
    if (!url.endsWith('.gif')) return `${url}/zoom${size}`;
  //}
  return url;
}

/**
 * 普通图片链接转换成带水印链接
 */
export function watermarkFormat(url) {
  if (!url) return;

  if (isMediaUrl(url)) {
    url = removeMediaUrlSuffix(url);
    if (isSupportWebp) return `${url}/watermark`;
    if (!url.endsWith('.gif')) return `${url}/watermarkpng`;
  }
  return url;
}

/**
 * HTML字符串中的图片链接添加水印标记
 */
export const htmlStringImage2Watermark = (htmlStr, imageSelector = 'img') => {
  let oDiv = document.createElement('div');
  oDiv.innerHTML = htmlStr;
  [...oDiv.querySelectorAll(imageSelector)]
    .filter(el => !['spaceline', 'facial-expression'].includes(el.className))
    .forEach(el => {
      if (el.src && isMediaUrl(el.src)) {
        el.src = removeMediaUrlSuffix(el.src);
        if (isSupportWebp) {
          el.src = `${el.src}/watermark`;
        } else if (!el.src.endsWith('.gif')) {
          el.src = `${el.src}/watermarkpng`;
        }
      }
    });
  setTimeout(() => {
    oDiv = null;
  }, 0);
  return oDiv.innerHTML;
};

/**
 * 删除HTML字符串中的图片
 */
export const removeImageFromHtml = (htmlStr, imageSelector = 'img') => {
  let oDiv = document.createElement('div');
  oDiv.innerHTML = htmlStr;
  [...oDiv.querySelectorAll(imageSelector)].forEach(el => {
    el.parentNode.removeChild(el);
  });
  setTimeout(() => {
    oDiv = null;
  }, 0);
  return oDiv.innerHTML;
};

export const responseErrorFormat = (url, httpStatus, errorMsg) =>
  `<div style="line-height: 1.5;">
    <div>URL：${url}</div>
    <div>HTTP状态码：${httpStatus}</div>
    <div>当前时间：${new Date().toISOString()}</div>
    <div>服务器信息：${errorMsg}</div>
  </div>`;
